"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRStMxOtpUrl = void 0;
class XHRStMxOtpUrl {
    constructor() {
        this.name = this.constructor.name;
    }
    async handleRequest(request) {
        if (request.url.includes('mb-api-cm-operations')) {
            return null;
        }
        return Promise.resolve(request);
    }
}
exports.XHRStMxOtpUrl = XHRStMxOtpUrl;
//# sourceMappingURL=xhrStMxOtpUrl.js.map